export default __webpack_public_path__ + "static/media/java.4985ed45.svg";